import fetchCustomerRepresentativeQueue from './fetchCustomerRepresentativeQueue'
import fetchAllRepresentativesOfOneCustomer from './fetchAllRepresentativesOfOneCustomer'

// CODE_COMMENTS_11
export default [
  ...fetchAllRepresentativesOfOneCustomer,
  ...fetchCustomerRepresentativeQueue,
]
